import { isADateBiggerThanB } from '@global/helpers/general';
import { Box, Typography } from '@mui/material';
import GenericFormAlert from './generic';

export default function InProgress({
  txnInfo,
  contactUs
}: {
  txnInfo: any,
  contactUs: () => void
}) {
  const datePassed = isADateBiggerThanB(new Date(), txnInfo?.expectedCompletionDate?.maxDate);
  return (
    <>
      {datePassed && (
        <GenericFormAlert
          theme="light"
          title={`We're  sorry for the delay in your verification.`}
          caption={
            <Box sx={{ display: 'flex', flexFlow: 'column', alignItems: 'center' }}>
              <Typography variant="body2">
                Our team is actively working on it and we will update you
              </Typography>
              <Typography variant="body2">
                {'soon. '}
                <Box
                  component="span"
                  sx={{
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    color: 'primary.main'
                  }}
                  onClick={() => {
                    contactUs();
                  }}>
                  {'Contact us'}
                </Box>
                {' for any assistance.'}
              </Typography>
            </Box>
          }
        />
      )}
      {!datePassed && (
        <GenericFormAlert
          caption={
            <Box
              sx={{ display: 'flex', flexFlow: 'column', rowGap: '.85rem', alignItems: 'center' }}>
              <Typography variant="body2" sx={{ color: 'bg.white', fontWeight: '600' }}>
                Expected Verification completion by
              </Typography>
              <Typography
                sx={{
                  fontSize: '16px',
                  fontFamily: 'Poppins',
                  fontWeight: '600',
                  color: 'secondary.main'
                }}>
                {/* {displayTime(txnInfo?.expectedCompletionDate?.maxDate, 'Do MMMM YYYY')} */}
                2-3 weeks
              </Typography>
            </Box>
          }
        />
      )}
    </>
  );
}
